const environment = {
  api: process.env.REACT_APP_API_URL || '',
  map_api_key: process.env.REACT_APP_MAP_API_KEY || '',
  planTypeId: process.env.REACT_APP_PLAN_TYPE_ID || '',
  apiUrl: process.env.REACT_APP_API_URL || '',
  userRoleId: process.env.REACT_APP_USER_ROLE_ID || '',
  customerRoleId: process.env.REACT_APP_CUSTOMER_ROLE_ID || '',
  glRoleId: process.env.REACT_APP_GL_ROLE_ID || '',
  adminRoleId: process.env.REACT_APP_ADMIN_ROLE_ID || '',
  assistantGlRoleId: process.env.REACT_APP_ASSISTANT_GL_ROLE_ID || '',
  connectmeetmanagerRoleId: process.env.REACT_APP_CMM_ROLE_ID || '',
  thankYouTrackerRoleId: process.env.REACT_APP_TY_TRACKER_ROLE_ID || '',
  groupLeaderRoleIds: [
    process.env.REACT_APP_GL_ROLE_ID || '',
    process.env.REACT_APP_ASSISTANT_GL_ROLE_ID || ''
  ],
  thankYouRoleIds: [
    process.env.REACT_APP_GL_ROLE_ID || '',
    process.env.REACT_APP_ASSISTANT_GL_ROLE_ID || '',
    process.env.REACT_APP_TY_TRACKER_ROLE_ID || ''
  ],
  professionType: process.env.REACT_APP_PROFESSION_TYPE_ID || '',
  productTypeId: process.env.REACT_APP_PRODUCT_TYPE_ID || '',
  sasurl: process.env.REACT_APP_SAS_URL || '',
  container: process.env.REACT_APP_STORAGE_CONTAINER || '',
};
export default environment;
